/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 首页推荐列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetRecommendListParams {
  constructor(
    public page: number,
    public size: number,
    public sort: "HOT_RECOMMEND" | "RECENTLY_PERFORMANCE" | "RECENTLY_SALE"
  ) {}
}

export default async function (
  params: GetRecommendListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/recommends`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
